import {
  HOMEPAGE_CAROUSEL_INITIAL_WINDOW,
  HOMEPAGE_CAROUSEL_OVERSCAN,
} from './homepageCarousel.constants';

/**
 * Inclusive-exclusive index range of carousel cards that should be in the DOM.
 * Before the track has a measured width, only the first window is returned.
 */
export function visibleCarouselRange({
  itemCount,
  scrollLeft = 0,
  viewportWidth = 0,
  cardWidth = 0,
  gap = 0,
  overscan = HOMEPAGE_CAROUSEL_OVERSCAN,
  initialWindow = HOMEPAGE_CAROUSEL_INITIAL_WINDOW,
}) {
  const count = Math.max(0, itemCount || 0);
  if (count === 0) return { start: 0, end: 0 };
  if (cardWidth <= 0 || viewportWidth <= 0) {
    return { start: 0, end: Math.min(count, initialWindow) };
  }

  const stride = cardWidth + gap;
  const visible = Math.max(1, Math.ceil(viewportWidth / stride));
  const windowSize = visible + overscan * 2;
  const maxStart = Math.max(0, count - windowSize);
  const start = Math.min(maxStart, Math.max(0, Math.floor(scrollLeft / stride) - overscan));
  return { start, end: Math.min(count, start + windowSize) };
}

/**
 * Width of the empty blocks that stand in for cards outside the window.
 * The flex gap between a spacer and a card is subtracted so the scroll width
 * stays the same as if every card were rendered.
 */
export function carouselSpacerWidths({ start, end, itemCount, cardWidth, gap = 0 }) {
  if (!cardWidth || cardWidth <= 0) return { lead: 0, tail: 0 };
  const stride = cardWidth + gap;
  const lead = start > 0 ? start * stride - gap : 0;
  const hidden = Math.max(0, (itemCount || 0) - end);
  const tail = hidden > 0 ? hidden * stride - gap : 0;
  return { lead: Math.max(0, lead), tail: Math.max(0, tail) };
}
